import Link from 'next/link'
import styles from './Logo.module.scss'
import { CommitAction } from './CommitAction'

export function Logo({
  className = '',
  color = '#2F2F2F',
  logoColor = 'default',
  withoutLink = false
}) {
  return (
    <>
      {!withoutLink &&
        <Link href={'/'} passHref className={`${className} ${styles.logo}`}>
          <CommitAction color={color} logoColor={logoColor}/>
        </Link>
      }
      {withoutLink &&
        <div className={`${className} ${styles.logo}`}>
          <CommitAction color={color} logoColor={logoColor}/>
        </div>
      }
    </>
  )
}
